import { createSlice } from "@reduxjs/toolkit";

const loadStatus = {
  fulfilled: "fulfilled",
  pending: "pending",
  rejected: "rejected",
};

const initialState = {
  subjectsList: [],
  subjectsLoadStatus: loadStatus.fulfilled,
  checkedSubjects: [],
  showingColumns: [
    "price",
    "frequency",
    "orders_per_position",
    "damping_coefficient",
    "proceeds_per_position",
    "weighted_price",
  ],
  predictShowingColumns: [
    "predict_orders_per_article_coeff",
    "predict_weighted_price_coeff",
    "predict_proceeds_per_article_coeff",
  ],
  subjectsData: [],
  subjectsCache: {},
  monthWidth: undefined,
};

const analysisBySeasonalitySlice = createSlice({
  name: "analysisBySeasonality",
  initialState,
  reducers: {
    addSubject(state, action) {
      state.subjectsList.push(action.payload);
    },
    setSubjectsLoadStatus(state, action) {
      state.subjectsLoadStatus = action.payload;
    },
    setSubjects(state, { payload: newSubjectsList }) {
      state.subjectsList = newSubjectsList;
    },
    removeSubject(state, action) {
      state.subjectsList = state.subjectsList.filter(subjectName => subjectName !== action.payload);
      state.subjectsData = state.subjectsData.filter(subject => subject.name !== action.payload);
    },
    setShowingColumns(state, action) {
      state.showingColumns = action.payload;
    },
    setPredictShowingColumns(state, action) {
      state.predictShowingColumns = action.payload;
    },
    setSubjectsMap(state, action) {
      state.subjects = [...state.subjects, ...action.payload];
    },
    setSubjectsData(state, action) {
      action.payload.forEach(item => {
        const key = `${item.name}_${item.monthWidth === true ? "month" : "week"}`;
        state.subjectsCache[key] = item;
        state.subjectsData = state.subjectsData.filter(i => i.name !== item.name);
        state.subjectsData.push(item);
      });
    },
    setSubjectsDataFromCache(state) {
      const currentWidth = state.monthWidth === true ? "month" : "week";
      const names = state.subjectsList;

      state.subjectsData = names
        .map(name => {
          const key = `${name}_${currentWidth}`;
          return state.subjectsCache[key];
        })
        .filter(Boolean);
    },
    setMonthWidth(state, action) {
      state.monthWidth =
        typeof action.payload === "boolean" && action.payload === true ? true : undefined;
    },
  },
});

export const {
  addSubject,
  setSubjects,
  setSubjectsLoadStatus,
  removeSubject,
  setShowingColumns,
  setPredictShowingColumns,
  setSubjectsData,
  setSubjectsDataFromCache,
  setSubjectsMap,
  setMonthWidth,
} = analysisBySeasonalitySlice.actions;
export default analysisBySeasonalitySlice.reducer;
